const oauthClientId =
  "4bad94e1b31a204e3247cfd0e10a68f83fbfd23112fd08325b17f6cadb56ea18";
const oauthPath = "/oauth/nb_auth";
const oauthRedirect = "https://stage.donorstack.com/oauth/nb_auth";

// sets a cookie that expires 24 hrs from now
const setCookie = function (name, value) {
  let today = new Date();
  let tomorrow = new Date(today.getTime() + 24 * 3600);
  document.cookie =
    name + "=" + value + "; " + tomorrow.toGMTString() + "; path=/";
};

const connectNationBuilder = function (dialog) {
  let slug = $("input[data-nb-slug-input]").val();
  $(dialog).dialog("close");
  setCookie("nbslug", slug);
  setCookie("nbcid", $("input[data-nb-campaign-id]").val());
  window.open(
    "https://" +
      slug +
      ".nationbuilder.com/oauth/authorize?response_type=code&" +
      "client_id=" +
      $("input[data-nb-client-id]").val() +
      "&redirect_uri=" +
      $("input[data-nb-redirect]").val(),
    "_self",
  );
};

const validateContributionLimitForms = function () {
  $("input[data-limit-submit]").each(function () {
    let id = $(this).attr("data-limit-submit");
    let input = $("input[data-individual-amount-" + id + "]");
    if (input && (input.val() === null || input.val() === "")) {
      $(this).attr("disabled", "disabled");
    } else {
      $(this).removeAttr("disabled");
    }
  });
};

let executingRemoteCall = false;
let currentAlert = null;

const toggleAlertDetail = function (alertId) {
  if (!executingRemoteCall) {
    $("#alert-detail-" + alertId).toggle("fast");
  }
};

// Expose to window for use in view templates
window.toggleAlertDetail = toggleAlertDetail;

const showSnoozeMenu = function (alertId) {
  executingRemoteCall = true;
  let menu = $("#snooze-menu");
  if (menu.is(":visible")) {
    menu.hide();
    window.setTimeout(function () {
      executingRemoteCall = false;
    }, 1000);
  } else {
    currentAlert = alertId;
    menu.menu("enable");
    menu.show();
    menu.position({
      my: "top",
      at: "bottom",
      of: "a[data-alert-snooze=" + alertId + "]",
    });
  }
};

$(function () {
  $("#focus").focus();

  $("#snooze-menu").menu({
    select: function (event, ui) {
      $(this).menu("disable");
      let alertElt = $(
        "tr[data-alert-toggle=alert-detail-" + currentAlert + "]",
      );
      let that = this;
      $.ajax({
        method: "POST",
        url: alertElt.attr("data-alert-url") + "/snooze",
        data: { until: ui.item.text() },
      })
        .done(function (data) {
          alertElt.attr("class", "viewed-alert");
          $(that).hide();
          executingRemoteCall = false;
        })
        .error(function (error) {
          alert("We were unable to snooze this alert. Please try again.");
          $(that).hide();
        });
    },
  });

  $("a[data-alert-snooze]").click(function () {
    showSnoozeMenu($(this).attr("data-alert-snooze"));
  });

  $(".alert-row").click(function () {
    let alertId = $(this).attr("data-alert-id");
    toggleAlertDetail(alertId);
  });

  $("a[data-remote]").on("ajax:before", function (e) {
    executingRemoteCall = true;
    $(this).parents("tr").attr("class", "viewed-alert");
  });

  $("a[data-remote]").on("ajax:complete", function (event, data) {
    executingRemoteCall = false;
    if ($(this).hasClass("alert-viewed-toggle")) {
      $(this).parents("tr").attr("class", "");
      let span = $(this).find("span");
      let viewedStatusCell = $(this).parents("tr").find("td.viewed-status");
      if (span.hasClass("glyphicon-repeat")) {
        span.removeClass("glyphicon-repeat");
        span.addClass("glyphicon-ok");
        viewedStatusCell.text("");
      } else {
        span.removeClass("glyphicon-ok");
        span.addClass("glyphicon-repeat");
        let json = JSON.parse(data.responseText);
        viewedStatusCell.text(json.viewed);
      }
    }
  });

  $("a[data-nbconnect]").click(function () {
    let popupDiv = $("#nb-connect-popup");
    popupDiv.dialog({
      resizable: false,
      height: 200,
      width: 600,
      modal: true,
      buttons: {
        Connect: function () {
          connectNationBuilder(this);
        },
        Cancel: function () {
          $(this).dialog("close");
        },
      },
    });
    $("input[data-nb-slug-input]").keypress(function (event) {
      if (event.which == 13) {
        connectNationBuilder(popupDiv);
      }
    });
    return false;
  });

  $("input[data-individual-amount]").on("keyup", function () {
    validateContributionLimitForms();
  });

  // flash on successful campaign settings update
  $("form.edit_campaign").on("ajax:success", function () {
    $("form.edit_campaign").hide().fadeIn("fast");
  });

  validateContributionLimitForms();
});
